import { useIsMobile } from '@brunommsilva/react-foundations';

// The top bar is a toolbar with a line under it.
const TOP_BAR_BORDER = 1;
const TOOLBAR_HEIGHT_MOBILE = 56;
const TOOLBAR_HEIGHT_DESKTOP = 64;

// How much room the assistant takes from the app when it is docked at the side of a large screen, and how far
// its button and window sit from the corner when they float.
const ASSISTANT_DOCK_WIDTH = 400;
const ASSISTANT_CORNER_OFFSET = 24;

// What is in front of what: what sticks below the bars, the bars, and the assistant over all of them.
const STICKY_BELOW_BAR_Z_INDEX = 1000;
const BAR_Z_INDEX = 1100;
const ASSISTANT_Z_INDEX = 1200;

/**
 * The measures of the page, and what is in front of what. The top bar is as tall as its toolbar and the
 * line under it, and what is stuck to the bar has to start after it. Everyone asks for them here.
 */
const useLayout = () => {
  const isMobile = useIsMobile();
  const toolbarHeight = isMobile
    ? TOOLBAR_HEIGHT_MOBILE
    : TOOLBAR_HEIGHT_DESKTOP;

  return {
    toolbarHeight,
    topBarHeight: toolbarHeight + TOP_BAR_BORDER,
    dockWidth: ASSISTANT_DOCK_WIDTH,
    assistantCornerOffset: ASSISTANT_CORNER_OFFSET,
    stickyBelowBarZIndex: STICKY_BELOW_BAR_Z_INDEX,
    barZIndex: BAR_Z_INDEX,
    assistantZIndex: ASSISTANT_Z_INDEX,
  };
};

export default useLayout;
